var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSupport = function SvgSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    strokeWidth: 1.5,
    viewBox: "2 2 19 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.56 20H4.859A.86.86 0 0 1 4 19.143v-5.11a.86.86 0 0 1 .858-.857H6.56a.86.86 0 0 1 .857.858v5.109a.86.86 0 0 1-.857.857M12.527 16.594l1.825.05c.257 0 .515-.074.723-.221l2.879-1.985c.563-.404 1.372-.294 1.838.355.465.65.085 1.434-.503 1.85l-2.634 1.85a2.5 2.5 0 0 1-.539.282L13.3 19.84a3.4 3.4 0 0 1-1.495-.037l-2.267-.564a3.7 3.7 0 0 0-.82-.098H7.43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.527 16.594h1.262c.71 0 1.286-.576 1.286-1.287v-.257c0-.588-.404-1.102-.98-1.25l-1.948-.49a4.4 4.4 0 0 0-.968-.122c-.784 0-1.568.233-2.217.674L7.418 14.89M8 5.605c0 .693.274 1.355.736 1.837l3.077 2.909a1 1 0 0 0 1.374 0l3.077-2.909A2.6 2.6 0 0 0 17 5.605a2.67 2.67 0 0 0-.736-1.837A2.4 2.4 0 0 0 14.504 3a2.45 2.45 0 0 0-1.759.768l-.245.256-.245-.256A2.4 2.4 0 0 0 10.495 3a2.45 2.45 0 0 0-1.76.768A2.6 2.6 0 0 0 8 5.605"
  })));
};
export default SvgSupport;